module.exports = __webpack_public_path__ + "img/client_logo.f3375ab4.webp";